

import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export function sliderIcons() {
    document.addEventListener( 'DOMContentLoaded', function () {
    const blocks = document.querySelectorAll('.blockSliderIcons__sliders');
    if(blocks){

        blocks.forEach(block=>{
            new Splide(block, {
              type   : 'loop',
              drag   : 'free',
              focus  : 'center',
              pagination: false,
              arrows: false,
              pauseOnHover: false,
              pauseOnFocus: false,

              perPage: 3,
              autoScroll: {
                speed: 2,
              },
                  
              breakpoints: {
                1100: {
                  perPage: 2,
                  autoScroll: {
                    speed: 2,
                  },
                  pagination : false,
                  padding: '3rem',
                  drag: 'false',
                  pauseOnHover: false,
                  pauseOnFocus: false,
                },
                840: {
                  perPage : 2,
      
                  pagination : false,
                  padding: '3rem',
                  drag: 'false',
                  pauseOnHover: false,
                  pauseOnFocus: false,
                },
                768: {
                  perPage : 1,
                  pagination : false,
                  padding: '12rem',
                  drag: 'false',
                  pauseOnHover: false,
                  pauseOnFocus: false,
                },
                660: {
                  perPage : 1,
                  pagination : false,
                  padding: '7rem',
                  drag: 'false',
                  pauseOnHover: false,
                  pauseOnFocus: false,
                },
                450: {
                  perPage : 1,
                  padding: '0rem',
                  drag: 'false',
                  pauseOnHover: false,
                  pauseOnFocus: false,
                },
           
              }
          
              }).mount({ AutoScroll });
        });
      }
    })
}